'use client';

import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

export const Headline = styled.div`
  padding-bottom: 40px;
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-top: 1rem;
    padding-bottom: 2rem;
  }
`;

export default function ProductHeading({ product, withSupportTitle = true }) {
  const translate = useTranslations();
  const supportTitle = translate('breadcrumb-support').toLowerCase();

  return (
    <Headline>
      <Typography variant="h1">
        {product.content} {withSupportTitle && supportTitle}
      </Typography>
    </Headline>
  );
}
